import React from 'react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { LoadingSkeleton } from '@atlassian/help-center-common-component/loading';

export const Loader = ({ height = 10 }) => (
    <LoadingSkeleton backgroundColor={token('color.skeleton', colors.N30)} height={height} />
);
